export const isLocal = "localhost" === window.location.hostname;

export const isStaging = [
  "valor-staging.dts.corp.local",
  "valord.alzp.tgscloud.net",
].includes(window.location.hostname);

export const isProd = [
  "valor.dts.corp.local",
  "valor.alzp.tgscloud.net",
].includes(window.location.hostname);
